import { zeroCheckboxStyles } from '@genesislcap/foundation-zero';
import { css, ElementStyles } from '@microsoft/fast-element';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';

export const customCheckboxStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${zeroCheckboxStyles(context, definition)}
  :host([aria-checked="true"]) .control {
    border: calc(var(--stroke-width) * 1px) solid rgb(88 155 91);
    color: rgb(88 155 91) !important;
    background: rgb(88 155 91) !important;
  }

  .checked-indicator {
    background-image: none;
  }
`;
